module.exports = __webpack_public_path__ + "static/gravity-bold-webfont-318aece8d5f9495d4c49f1cab473f16b.woff";